import { Button, Col, Row, Space, Typography } from "antd";
import { birthday2Age, convertIosStringToDate2 } from "helper/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import "./PrintBBHC.scss";
import dayjs from "dayjs";

import { sharedDirectory } from "api";
import { phuongPhapVoCamOptions } from "../Consultation/config";
import { listOptionMat } from "pages/Examination/components/InforDetail/DetailTabInfo/components/ConcludePrecription/ConcludeIcd/ConcludeIcd.config";

const PrintBBHC = React.forwardRef((props: any, ref) => {
  const { closeModal, dmBuong, dmGiuong, dmPPPT, openModal } = props;
  const [data, setData] = useState<any>(null);
  const printRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    setData: setData,
  }));
  const [danToc, setDanToc] = useState([]);
  const fetchDanToc = async () => {
    try {
      let response = await sharedDirectory.getListDanToc();
      setDanToc(response.data.data);
    } catch (err) {}
  };
  useEffect(() => {
    fetchDanToc();
  }, [openModal]);
  const onPrintSheet = () => {
    window.print();
  };

  return (
    <div className="phieu-bbhc">
      <div>
        <div
          ref={printRef}
          style={{
            width: "210mm",
            minHeight: "250mm",
            position: "relative",
          }}
        >
          <div style={{ padding: "48px 24px 0px 24px" }}>
            <Row>
              <Col span={8}>
                <Row>BỘ Y TẾ</Row>
                <Row style={{ fontWeight: "bold", fontSize: "12px" }}>
                  BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                </Row>
                <Row>Khoa Mắt tổng hợp</Row>
              </Col>
              <Col span={11}>
                <Row
                  justify={"center"}
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                >
                  CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                </Row>
                <Row justify={"center"}>Độc lập – Tự do – Hạnh phúc</Row>
                <Row justify={"center"}>----------------------</Row>
              </Col>
              <Col span={5}>
                <Row justify={"start"}>MS: 40/BV-01</Row>
                <Row>Số vào viện:&nbsp;{data?.maPhieuKham ?? ""}</Row>
              </Col>
            </Row>

            <Row
              justify={"center"}
              style={{ fontWeight: "bold", padding: "10px", fontSize: "24px" }}
            >
              TRÍCH BIÊN BẢN HỘI CHẨN
            </Row>

            <Row style={{ padding: "4px 0" }}>
              <Col span={12} style={{ display: "flex" }}>
                - Họ tên người bệnh:{" "}
                <span style={{ fontWeight: "bold" }}>
                  &nbsp;{data?.tenBenhNhan && data?.tenBenhNhan?.toUpperCase()}
                </span>
              </Col>
              <Col span={6}>Tuổi: {birthday2Age(data?.ngaySinh) ?? ""}</Col>
              <Col span={3} style={{ display: "flex" }}>
                <label className="custom-checkbox">
                  <input
                    checked={data?.gioiTinh === 0 ? true : false}
                    type="checkbox"
                  />
                  <span></span>
                </label>
                <span style={{ paddingLeft: "5px" }}>Nam</span>
              </Col>
              <Col span={3} style={{ display: "flex" }}>
                <label className="custom-checkbox">
                  <input
                    checked={data?.gioiTinh === 1 ? true : false}
                    type="checkbox"
                  />
                  <span></span>
                </label>
                <span style={{ paddingLeft: "5px" }}>Nữ</span>
              </Col>
            </Row>
            <Row style={{ padding: "4px 0" }}>
              <Col span={12}>
                - Dân tộc:&nbsp;
                {danToc?.find((it) => it.id == data?.danToc)?.name ?? ""}
              </Col>
              <Col span={12}>Nghề nghiệp:&nbsp;{data?.ngheNghiep}</Col>
            </Row>
            <Row style={{ padding: "4px 0" }}>
              <Col span={12}>
                - Đã điều trị từ ngày:{" "}
                {convertIosStringToDate2(data?.thoiGianDieuTriTu)?.format(
                  "DD/MM/YYYY"
                )}
                <span style={{ fontWeight: "bold" }}>{}</span>
              </Col>
              <Col span={12}>
                đến ngày:{" "}
                {data?.thoiGianDieuTriDen
                  ? convertIosStringToDate2(data?.thoiGianDieuTriDen)?.format(
                      "DD/MM/YYYY"
                    )
                  : convertIosStringToDate2(data?.thoiGianDieuTriTu)?.format(
                      "DD/MM/YYYY"
                    )}
                {/* {convertIosStringToDate2(data?.thoiGianDieuTriDen)?.format(
                  "DD/MM/YYYY"
                )} */}
                <span style={{ fontWeight: "bold" }}>{}</span>
              </Col>
            </Row>
            <Row style={{ padding: "4px 0" }}>
              <Col span={6}>
                - Tại số giường:{" "}
                <span>
                  {dmGiuong.find((it) => it.id === data?.giuong)?.soGiuong}
                </span>
              </Col>
              <Col span={6}>
                Buồng:{" "}
                <span>
                  {dmBuong.find((it) => it.id === data?.buong)?.tenPhong}
                </span>
              </Col>
              <Col span={12}>Khoa: Mắt tổng hợp</Col>
            </Row>
            <Row style={{ padding: "4px 0" }}>
              <Col span={3}>- Chẩn đoán:&nbsp; </Col>
              <Col flex={"auto"}>
                {data?.idBenhHoiChan ?? ""}{" "}
                {data?.idBenhHoiChan && data?.benhHoiChan ? "-" : ""}{" "}
                {data?.benhHoiChan ?? ""}
              </Col>
            </Row>
            {data?.thoiGianHoiChan ? (
              <Row style={{ padding: "4px 0" }}>
                <Col>- Hội chẩn lúc:&nbsp;</Col>
                {convertIosStringToDate2(data?.thoiGianHoiChan).format(
                  "HH   [giờ]    mm [phút], [ngày] DD [tháng] MM [năm] YYYY"
                )}
              </Row>
            ) : (
              <Row style={{ padding: "4px 0" }}>
                <Col>- Hội chẩn lúc:&nbsp;&nbsp;&nbsp;&nbsp;</Col>
                <Col>giờ&nbsp;&nbsp;&nbsp;&nbsp;</Col>
                <Col>phút, ngày&nbsp;&nbsp;&nbsp;&nbsp;</Col>
                <Col>tháng&nbsp;&nbsp;&nbsp;&nbsp;</Col>
                <Col>năm&nbsp;&nbsp;&nbsp;&nbsp;</Col>
              </Row>
            )}
            <Row style={{ padding: "4px 0" }}>
              <Col span={12}>- Chủ tọa: {data?.chuToaHoiChan}</Col>
              <Col span={12}>Thư kí: {data?.thuKyHoiChan}</Col>
            </Row>
            <Row style={{ height: "80px", padding: "4px 0" }}>
              - Thành viên tham gia: {data?.thanhPhanThamGia ?? ""}
            </Row>
            <Row>
              <Row>
                <Typography.Text style={{ fontWeight: "bold" }}>
                  Tóm tắt diễn biến bệnh, quá trình điều trị và chăm sóc người
                  bệnh:
                </Typography.Text>
              </Row>
              <Row style={{ minHeight: "50px" }}>
                {data?.quaTrinhDienTienBenh
                  ?.split("\n")
                  .map((item) => (
                    <Row style={{ fontWeight: "normal" }}>{item}</Row>
                  )) ?? ""}
              </Row>
            </Row>

            <Row>
              <Row>
                <Typography.Text style={{ fontWeight: "bold" }}>
                  Kết luận (sau khi đã khám lại và thảo luận):{" "}
                </Typography.Text>
              </Row>
              <Row style={{ height: "80px" }}>
                <Typography.Text style={{ fontWeight: "normal" }}>
                  {data?.ketLuan ?? ""}
                </Typography.Text>
              </Row>
            </Row>

            <Row style={{ height: "180px" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <div style={{ fontWeight: "bold" }}>Hướng điều trị tiếp:</div>
                {/* {data?.khac ? (
                  <div> {data?.khac ?? ""}</div>
                ) : ( */}
                <>
                  <div>
                    1. Phương pháp phẫu thuật:{" "}
                    {/* {dmPPPT?.find((e) => e.id === data?.phuongPhapPhauThuat)
                      ?.tenDichVu ?? ""}{" "}
                    - {listOptionMat.find((e) => e.value === data?.mat)?.label} */}
                    {listOptionMat.find((e) => e.value === data?.mat)?.label} -{" "}
                    {dmPPPT?.find((e) => e.id === data?.phuongPhapPhauThuat)
                      ?.tenDichVu ?? ""}{" "}
                  </div>
                  <div>
                    2. Phương pháp vô cảm:{" "}
                    {phuongPhapVoCamOptions.find(
                      (it) => it.value === data?.phuongPhapVoCam
                    )?.label || ""}
                  </div>
                  <div>3. Phẫu thuật viên: {data?.phauThuatVien ?? ""}</div>
                  <div>
                    4. Ngày phẫu thuật:{" "}
                    {convertIosStringToDate2(data?.ngayPhauThuat)?.format(
                      "DD/MM/YYYY"
                    )}
                  </div>
                  <div>Khác: {data?.khac}</div>
                </>
                {/* )} */}
              </Space>
            </Row>
          </div>
          <Row
            style={{
              position: "absolute",
              // bottom: 0,
              right: 0,
              paddingBottom: "10px",
            }}
          >
            <Col span={12}>
              <Row justify={"center"}>
                {data?.thoiGianHoiChan
                  ? dayjs(data?.thoiGianHoiChan).format(
                      `Ngày DD [tháng] MM [năm] YYYY`
                    )
                  : dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
              </Row>
              <Row justify={"center"}>
                <span style={{ fontWeight: "700" }}>THƯ KÝ</span>
              </Row>
              <Row justify={"center"} style={{ marginTop: "48px" }}>
                <span style={{ fontWeight: "700" }}>
                  {data?.thuKyHoiChan ?? ""}
                </span>
              </Row>
            </Col>
            <Col span={12}>
              <Row justify={"center"}>
                {data?.thoiGianHoiChan
                  ? dayjs(data?.thoiGianHoiChan).format(
                      `Ngày DD [tháng] MM [năm] YYYY`
                    )
                  : dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
              </Row>
              <Row justify={"center"}>
                <span style={{ fontWeight: "700" }}>CHỦ TỌA</span>
              </Row>
              <Row justify={"center"} style={{ marginTop: "48px" }}>
                <span style={{ fontWeight: "700" }}>
                  {data?.chuToaHoiChan ?? ""}{" "}
                </span>
              </Row>
            </Col>
          </Row>
        </div>
        <Row justify={"end"} gutter={[16, 16]} style={{ paddingTop: "10px" }}>
          {/* <Space direction="horizontal"> */}
          <Col>
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
          </Col>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrintSheet}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="phieu-bbhc"
            onAfterPrint={closeModal}
          />
        </Row>
      </div>
    </div>
  );
});

export default PrintBBHC;
